import React, { FC } from 'react';
import CommonTreeViewItem from './CommonTreeViewItem';
import { List } from '@mui/material';

export interface GenericTreeItem {
    name: string;
    children: GenericTreeItem[];
    id: string | number;
    [key: string]: any;
}

interface CommonTreeViewProps {
    nodes: GenericTreeItem[];
    activeId?: number | string;
    unfoldTree?: boolean;
    onItemClick: (item: GenericTreeItem) => void;
    nodeInitialOpenDropdown?: (node: GenericTreeItem) => boolean;
}

const CommonTreeView: FC<CommonTreeViewProps> = ({
    nodes,
    activeId,
    onItemClick,
    unfoldTree,
    nodeInitialOpenDropdown,
}) => {
    const onItemClickHandler = (item: GenericTreeItem) => {
        // add functionality to the whole tree when an action on an item is executed
        onItemClick(item);
    };

    return (
        <List component="nav" sx={{ width: '100%' }}>
            {nodes.map((childNode) => (
                <CommonTreeViewItem
                    nodeInitialOpenDropdown={nodeInitialOpenDropdown}
                    node={childNode}
                    key={childNode.id}
                    activeId={activeId}
                    onItemClickHandler={onItemClickHandler}
                    indentation={11}
                    unfoldTree={unfoldTree}
                />
            ))}
        </List>
    );
};

export default React.memo(CommonTreeView);
